<router-outlet [id]="Reload"> </router-outlet>
<loading-animation></loading-animation>

<div class="popup" (click)="closePopup()">
  <router-outlet name="layover"></router-outlet>
</div>
